var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'sf-mode' : _vm.sfMode, 'cursor-progress' : _vm.isLoading},attrs:{"id":"app"}},[(!_vm.sfMode)?_c('Header'):_vm._e(),(!_vm.sfMode)?_c('Menu'):_vm._e(),(_vm.loaded)?_c('router-view'):_vm._e(),(!_vm.sfMode && _vm.loaded)?_c('Footer'):_vm._e(),_c('LoadingScreen'),_c('Modal'),_c('MessageBox'),_c('Alert'),_c('FatalErrorOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }